/**
 * Do not edit directly
 * Generated on Fri, 18 Apr 2025 13:56:15 GMT
 */

export const components_form_spacing = 16;
export const components_quick_search_horizontal_corner_radius = 9999;
export const components_quick_search_horizontal_field_first_and_last_corner_radius = 32;
export const components_quick_search_horizontal_field_corner_radius = 6;
export const components_navigation_list_item_border_width = 1;
export const components_button_xs_font_size = 14;
export const components_button_xs_icon_size = 16;
export const components_button_xs_padding_top = 4;
export const components_button_xs_padding_right = 8;
export const components_button_xs_padding_bottom = 4;
export const components_button_xs_padding_left = 8;
export const components_button_s_font_size = 14;
export const components_button_s_icon_size = 20;
export const components_button_s_padding_top = 6;
export const components_button_s_padding_right = 12;
export const components_button_s_padding_bottom = 6;
export const components_button_s_padding_left = 12;
export const components_button_m_font_size = 16;
export const components_button_m_icon_size = 24;
export const components_button_m_padding_top = 8;
export const components_button_m_padding_right = 16;
export const components_button_m_padding_bottom = 8;
export const components_button_m_padding_left = 16;
export const components_badge_font_family = "General Sans";
export const components_badge_font_weight = "Semibold";
export const components_badge_font_size = 16;
export const components_badge_height = 28;
export const components_badge_corner_radius = 14;
export const components_radio_button_size = 20;
export const components_radio_button_border_width = 2;
export const components_tab_bar_horizontal_corner_radius = 24;
export const components_tab_bar_horizontal_item_corner_radius = 20;
export const components_tab_bar_horizontal_item_height = 40;
export const components_tab_bar_vertical_corner_radius = 30;
export const components_tab_bar_vertical_item_corner_radius = 24;
export const components_tab_bar_vertical_item_height = 48;
export const components_tab_bar_icon_top_corner_radius = 12;
export const components_tab_bar_icon_top_item_corner_radius = 8;
export const components_tab_bar_padding = 4;
export const components_tab_bar_background_color = "#F3F0ED";
export const components_tab_bar_border_color = "#E7E0D7";
export const components_tab_bar_border_width = 2;
export const components_tab_bar_item_hover_background_color = "#DED2C4";
export const components_tab_bar_item_current_background_color = "#352F28";
export const components_tab_bar_item_current_hover_background_color = "#1E1B18";
export const components_list_tinted_s_spacing = 8;
export const components_list_outlined_s_spacing = 8;
export const components_list_outlined_m_spacing = 12;
export const components_list_outlined_l_spacing = 12;
export const components_list_divider_spacing = 0;
export const components_carousel_controls_area_corner_radius = 24;
export const components_button_group_spacing = 8;
export const components_toggle_button_group_m_spacing = 8;
export const components_toggle_button_group_s_spacing = 4;
export const components_banner_corner_radius = 8;
export const components_banner_border_width = 2;
export const components_checkbox_corner_radius = 4;
export const components_checkbox_border_width = 2;
export const components_checkbox_size = 20;
export const components_tag_font_family = "General Sans";
export const components_tag_font_weight = "Semibold";
export const components_tag_s_height = 16;
export const components_tag_s_corner_radius = 2;
export const components_tag_s_padding_top = 1;
export const components_tag_s_padding_right = 4;
export const components_tag_s_padding_bottom = 3;
export const components_tag_s_padding_left = 4;
export const components_tag_m_height = 24;
export const components_tag_m_icon_size = 16;
export const components_tag_m_corner_radius = 4;
export const components_tag_m_padding_top = 4;
export const components_tag_m_padding_right = 6;
export const components_tag_m_padding_bottom = 4;
export const components_tag_m_padding_left = 6;
export const components_top_title_bar_title_font_family = "General Sans";
export const components_top_title_bar_title_font_weight = "Semibold";
export const components_top_title_bar_title_font_size = 16;
export const components_top_title_bar_actions_font_family = "General Sans";
export const components_top_title_bar_actions_font_weight = "Semibold";
export const components_top_title_bar_actions_font_size = 16;
export const components_icon_button_xs_icon_size = 20;
export const components_icon_button_s_icon_size = 24;
export const components_icon_button_m_icon_size = 32;
export const components_backdrop_color = "#00000033";
export const semantics_backgrounds_background_color = "#FFFFFF";
export const semantics_backgrounds_tinted_background_color = "#F3F0ED";
export const semantics_text_color = "#352F28";
export const semantics_text_secondary_color = "#675D4F";
export const semantics_text_inverted_color = "#FFFFFF";
export const semantics_icons_color = "#352F28";
export const semantics_icons_secondary_color = "#817564";
export const semantics_icons_inverted_color = "#FFFFFF";
export const semantics_links_color = "#352F28";
export const semantics_links_hover_color = "#D20029";
export const semantics_dividers_color = "#DED2C4";
export const semantics_dividers_tickness = 2;
export const semantics_controls_xs_height = 24;
export const semantics_controls_xs_corner_radius = 4;
export const semantics_controls_xs_focus_outer_ring_corner_radius = 8;
export const semantics_controls_s_height = 32;
export const semantics_controls_s_corner_radius = 6;
export const semantics_controls_s_focus_outer_ring_corner_radius = 10;
export const semantics_controls_m_height = 44;
export const semantics_controls_m_corner_radius = 6;
export const semantics_controls_m_focus_outer_ring_corner_radius = 10;
export const semantics_buttons_font_family = "General Sans";
export const semantics_buttons_font_weight = "Semibold";
export const semantics_buttons_xs_corner_radius = 12;
export const semantics_buttons_xs_focus_outer_ring_corner_radius = 16;
export const semantics_buttons_s_corner_radius = 16;
export const semantics_buttons_s_focus_outer_ring_corner_radius = 20;
export const semantics_buttons_m_corner_radius = 24;
export const semantics_buttons_m_focus_outer_ring_corner_radius = 28;
export const semantics_buttons_primary_background_color = "#E9002E";
export const semantics_buttons_primary_content_color = "#FFFFFF";
export const semantics_buttons_primary_hover_background_color = "#D20029";
export const semantics_buttons_primary_hover_content_color = "#FFFFFF";
export const semantics_buttons_secondary_background_color = "#DED2C4";
export const semantics_buttons_secondary_content_color = "#000000";
export const semantics_buttons_secondary_hover_background_color = "#DED2C4";
export const semantics_buttons_secondary_hover_content_color = "#000000";
export const semantics_buttons_tinted_neutral_background_color = "#DED2C4";
export const semantics_buttons_tinted_neutral_content_color = "#000000";
export const semantics_buttons_tinted_neutral_hover_background_color = "#DED2C4";
export const semantics_buttons_tinted_neutral_hover_content_color = "#000000";
export const semantics_buttons_tinted_primary_background_color = "#FCC7C0";
export const semantics_buttons_tinted_primary_content_color = "#A5001E";
export const semantics_buttons_tinted_primary_hover_background_color = "#FDB3A9";
export const semantics_buttons_tinted_primary_hover_content_color = "#900118";
export const semantics_buttons_filled_neutral_background_color = "#675D4F";
export const semantics_buttons_filled_neutral_content_color = "#FFFFFF";
export const semantics_buttons_filled_neutral_hover_background_color = "#5A5145";
export const semantics_buttons_filled_neutral_hover_content_color = "#FFFFFF";
export const semantics_buttons_filled_primary_background_color = "#E9002E";
export const semantics_buttons_filled_primary_content_color = "#FFFFFF";
export const semantics_buttons_filled_primary_hover_background_color = "#D20029";
export const semantics_buttons_filled_primary_hover_content_color = "#FFFFFF";
export const semantics_buttons_overlay_background_color = "#FFFFFFD9";
export const semantics_buttons_overlay_neutral_content_color = "#000000";
export const semantics_buttons_overlay_primary_content_color = "#BC0023";
export const semantics_buttons_transparent_neutral_content_color = "#1E1B18";
export const semantics_buttons_transparent_neutral_hover_content_color = "#000000";
export const semantics_buttons_transparent_primary_content_color = "#D20029";
export const semantics_buttons_transparent_primary_hover_content_color = "#A5001E";
export const semantics_buttons_outlined_border_width = 2;
export const semantics_buttons_outlined_neutral_content_color = "#1E1B18";
export const semantics_buttons_outlined_neutral_hover_content_color = "#000000";
export const semantics_buttons_outlined_neutral_hover_border_color = "#746959";
export const semantics_buttons_outlined_neutral_border_color = "#8F816F";
export const semantics_buttons_outlined_primary_content_color = "#D20029";
export const semantics_buttons_outlined_primary_hover_content_color = "#A5001E";
export const semantics_buttons_tinted_neutral_neutral_background_color = "#DED2C4";
export const semantics_buttons_tinted_neutral_neutral_content_color = "#000000";
export const semantics_buttons_tinted_neutral_neutral_hover_background_color = "#DED2C4";
export const semantics_buttons_tinted_neutral_neutral_hover_content_color = "#000000";
export const semantics_buttons_tinted_neutral_primary_background_color = "#E7E0D7";
export const semantics_buttons_tinted_neutral_primary_content_color = "#BC0023";
export const semantics_buttons_tinted_neutral_primary_hover_background_color = "#DED2C4";
export const semantics_buttons_tinted_neutral_primary_hover_content_color = "#A5001E";
export const semantics_input_fields_border_width = 2;
export const semantics_input_fields_font_size = 16;
export const semantics_input_fields_background_color = "#FFFFFF";
export const semantics_input_fields_placeholder_color = "#675D4F";
export const semantics_input_fields_text_color = "#352F28";
export const semantics_input_fields_icon_color = "#352F28";
export const semantics_input_fields_border_color = "#9D8E7A";
export const semantics_input_fields_hover_border_color = "#817564";
export const semantics_input_fields_valid_icon_color = "#168764";
export const semantics_input_fields_valid_border_color = "#3CA27D";
export const semantics_input_fields_valid_hover_icon_color = "#168764";
export const semantics_input_fields_valid_hover_border_color = "#168764";
export const semantics_input_fields_invalid_icon_color = "#E61827";
export const semantics_input_fields_invalid_border_color = "#FB5347";
export const semantics_input_fields_invalid_hover_icon_color = "#E61827";
export const semantics_input_fields_invalid_hover_border_color = "#E61827";
export const semantics_selectors_border_width = 2;
export const semantics_selectors_background_color = "#F3F0ED";
export const semantics_selectors_border_color = "#DED2C4";
export const semantics_selectors_shape_color = "#746959";
export const semantics_selectors_text_color = "#352F28";
export const semantics_selectors_icon_color = "#352F28";
export const semantics_selectors_hover_background_color = "#E7E0D7";
export const semantics_selectors_hover_border_color = "#D5C4AC";
export const semantics_selectors_hover_shape_color = "#675D4F";
export const semantics_selectors_selected_background_color = "#168764";
export const semantics_selectors_selected_content_color = "#FFFFFF";
export const semantics_selectors_selected_hover_background_color = "#026C4E";
export const semantics_selectors_selected_hover_content_color = "#FFFFFF";
export const semantics_selectors_neutral_selected_background_color = "#4D453B";
export const semantics_selectors_neutral_selected_content_color = "#FFFFFF";
export const semantics_selectors_neutral_selected_hover_background_color = "#352F28";
export const semantics_selectors_neutral_selected_hover_content_color = "#FFFFFF";
export const semantics_selectors_invalid_background_color = "#E61827";
export const semantics_selectors_invalid_content_color = "#FFFFFF";
export const semantics_selectors_invalid_hover_background_color = "#B9111D";
export const semantics_selectors_invalid_hover_content_color = "#FFFFFF";
export const semantics_indicators_background_color = "#DED2C4";
export const semantics_indicators_accents_background_color = "#E9002E";
export const semantics_indicators_accents_content_color = "#FFFFFF";
export const semantics_boxes_background_color = "#F3F0ED";
export const semantics_boxes_padding = 16;
export const semantics_boxes_border_width = 2;
export const semantics_boxes_border_color = "#E7E0D7";
export const semantics_boxes_corner_radius = 12;
export const semantics_cards_corner_radius = 8;
export const semantics_cards_title_font_family = "Branding";
export const semantics_cards_title_font_weight = "Bold";
export const semantics_cards_subtitle_font_family = "General Sans";
export const semantics_cards_subtitle_font_weight = "Medium";
export const semantics_cards_m_title_font_size = 24;
export const semantics_cards_m_subtitle_font_size = 14;
export const semantics_cards_s_title_font_size = 20;
export const semantics_cards_s_subtitle_font_size = 12;
export const semantics_overlays_corner_radius = 16;
export const semantics_layouts_s_margin_left_and_right = 16;
export const semantics_layouts_s_margin_top_and_bottom = 16;
export const semantics_layouts_s_gap = 16;
export const semantics_layouts_m_margin_left_and_right = 32;
export const semantics_layouts_m_margin_top_and_bottom = 24;
export const semantics_layouts_m_gap = 24;
export const semantics_layouts_l_margin_left_and_right = 48;
export const semantics_layouts_l_margin_top_and_bottom = 32;
export const semantics_layouts_l_gap = 24;
export const semantics_layouts_max_width = 1440;
export const semantics_focus_inner_ring_color = "#FFFFFF";
export const semantics_focus_inner_ring_width = 2;
export const semantics_focus_inner_ring_corner_radius_none = 0;
export const semantics_focus_inner_ring_corner_radius_xs = 4;
export const semantics_focus_inner_ring_corner_radius_s = 6;
export const semantics_focus_inner_ring_corner_radius_m = 8;
export const semantics_focus_inner_ring_corner_radius_l = 10;
export const semantics_focus_inner_ring_corner_radius_xl = 14;
export const semantics_focus_inner_ring_corner_radius_xxl = 18;
export const semantics_focus_inner_ring_corner_radius_full = 10001;
export const semantics_focus_outer_ring_color = "#2871E7";
export const semantics_focus_outer_ring_width = 2;
export const semantics_focus_outer_ring_corner_radius_none = 2;
export const semantics_focus_outer_ring_corner_radius_xs = 6;
export const semantics_focus_outer_ring_corner_radius_s = 8;
export const semantics_focus_outer_ring_corner_radius_m = 10;
export const semantics_focus_outer_ring_corner_radius_l = 12;
export const semantics_focus_outer_ring_corner_radius_xl = 16;
export const semantics_focus_outer_ring_corner_radius_xxl = 20;
export const semantics_focus_outer_ring_corner_radius_full = 10003;
export const semantics_navigation_item_neutral_current_background_color = "#4D453B";
export const semantics_navigation_item_neutral_current_content_color = "#FFFFFF";
export const semantics_navigation_item_neutral_current_hover_background_color = "#352F28";
export const semantics_navigation_item_neutral_current_hover_content_color = "#FFFFFF";
export const semantics_navigation_item_primary_current_background_color = "#E9002E";
export const semantics_navigation_item_primary_current_content_color = "#FFFFFF";
export const semantics_navigation_item_primary_current_hover_background_color = "#D20029";
export const semantics_navigation_item_primary_current_hover_content_color = "#FFFFFF";
export const semantics_emails_m_corner_radius = 16;
export const primitives_color_neutral_0 = "#FFFFFF";
export const primitives_color_neutral_50 = "#F3F0ED";
export const primitives_color_neutral_100 = "#E7E0D7";
export const primitives_color_neutral_150 = "#DED2C4";
export const primitives_color_neutral_200 = "#D5C4AC";
export const primitives_color_neutral_250 = "#C8B69D";
export const primitives_color_neutral_300 = "#B9A891";
export const primitives_color_neutral_350 = "#AB9B86";
export const primitives_color_neutral_400 = "#9D8E7A";
export const primitives_color_neutral_450 = "#8F816F";
export const primitives_color_neutral_500 = "#817564";
export const primitives_color_neutral_550 = "#746959";
export const primitives_color_neutral_600 = "#675D4F";
export const primitives_color_neutral_650 = "#5A5145";
export const primitives_color_neutral_700 = "#4D453B";
export const primitives_color_neutral_750 = "#413A31";
export const primitives_color_neutral_800 = "#352F28";
export const primitives_color_neutral_850 = "#292520";
export const primitives_color_neutral_900 = "#1E1B18";
export const primitives_color_neutral_950 = "#12110F";
export const primitives_color_neutral_1000 = "#000000";
export const primitives_color_primary_50 = "#FCEDEB";
export const primitives_color_primary_100 = "#FBDBD6";
export const primitives_color_primary_150 = "#FCC7C0";
export const primitives_color_primary_200 = "#FDB3A9";
export const primitives_color_primary_250 = "#FF9D92";
export const primitives_color_primary_300 = "#FF877B";
export const primitives_color_primary_350 = "#FF6D64";
export const primitives_color_primary_400 = "#FF4E4D";
export const primitives_color_primary_450 = "#FF1436";
export const primitives_color_primary_500 = "#E9002E";
export const primitives_color_primary_550 = "#D20029";
export const primitives_color_primary_600 = "#BC0023";
export const primitives_color_primary_650 = "#A5001E";
export const primitives_color_primary_700 = "#900118";
export const primitives_color_primary_750 = "#7B0013";
export const primitives_color_primary_800 = "#65040F";
export const primitives_color_primary_850 = "#500608";
export const primitives_color_primary_900 = "#380B05";
export const primitives_color_primary_950 = "#210A04";
export const primitives_color_secondary_50 = "#EFF0FB";
export const primitives_color_secondary_100 = "#DEE2F9";
export const primitives_color_secondary_150 = "#CCD3F9";
export const primitives_color_secondary_200 = "#BAC5F9";
export const primitives_color_secondary_250 = "#A7B7FA";
export const primitives_color_secondary_300 = "#94A9F9";
export const primitives_color_secondary_350 = "#7F9BF8";
export const primitives_color_secondary_400 = "#678EF7";
export const primitives_color_secondary_450 = "#4A81F6";
export const primitives_color_secondary_500 = "#2871E7";
export const primitives_color_secondary_550 = "#2469D7";
export const primitives_color_secondary_600 = "#1F5DC0";
export const primitives_color_secondary_650 = "#1A51A9";
export const primitives_color_secondary_700 = "#164593";
export const primitives_color_secondary_750 = "#103A7D";
export const primitives_color_secondary_800 = "#102F67";
export const primitives_color_secondary_850 = "#0E2551";
export const primitives_color_secondary_900 = "#0B1B3C";
export const primitives_color_secondary_950 = "#081028";
export const primitives_color_success_50 = "#E3F5EC";
export const primitives_color_success_100 = "#C8EADA";
export const primitives_color_success_150 = "#AEDFC9";
export const primitives_color_success_200 = "#95D4B9";
export const primitives_color_success_250 = "#7DC8A9";
export const primitives_color_success_300 = "#66BC99";
export const primitives_color_success_350 = "#50AF8B";
export const primitives_color_success_400 = "#3CA27D";
export const primitives_color_success_450 = "#279570";
export const primitives_color_success_500 = "#168764";
export const primitives_color_success_550 = "#047A58";
export const primitives_color_success_600 = "#026C4E";
export const primitives_color_success_650 = "#045F44";
export const primitives_color_success_700 = "#09513A";
export const primitives_color_success_750 = "#0F4432";
export const primitives_color_success_800 = "#103729";
export const primitives_color_success_850 = "#112A20";
export const primitives_color_success_900 = "#101E18";
export const primitives_color_success_950 = "#09130F";
export const primitives_color_warning_50 = "#FCEEE4";
export const primitives_color_warning_100 = "#FCDCC3";
export const primitives_color_warning_150 = "#FCCAA0";
export const primitives_color_warning_200 = "#FEB677";
export const primitives_color_warning_250 = "#FFA148";
export const primitives_color_warning_300 = "#FD8C01";
export const primitives_color_warning_350 = "#EA8100";
export const primitives_color_warning_400 = "#D77600";
export const primitives_color_warning_450 = "#C46B00";
export const primitives_color_warning_500 = "#B16100";
export const primitives_color_warning_550 = "#A05600";
export const primitives_color_warning_600 = "#8E4C00";
export const primitives_color_warning_650 = "#7D4200";
export const primitives_color_warning_700 = "#6C3900";
export const primitives_color_warning_750 = "#5B3000";
export const primitives_color_warning_800 = "#4A2702";
export const primitives_color_warning_850 = "#391F04";
export const primitives_color_warning_900 = "#281805";
export const primitives_color_warning_950 = "#180F04";
export const primitives_color_danger_50 = "#FBEEEB";
export const primitives_color_danger_100 = "#FADBD5";
export const primitives_color_danger_150 = "#FAC8BF";
export const primitives_color_danger_200 = "#FBB4A7";
export const primitives_color_danger_250 = "#FD9F8F";
export const primitives_color_danger_300 = "#FC8977";
export const primitives_color_danger_350 = "#FC715F";
export const primitives_color_danger_400 = "#FB5347";
export const primitives_color_danger_450 = "#FB252E";
export const primitives_color_danger_500 = "#E61827";
export const primitives_color_danger_550 = "#CF1522";
export const primitives_color_danger_600 = "#B9111D";
export const primitives_color_danger_650 = "#A30E18";
export const primitives_color_danger_700 = "#8E0A14";
export const primitives_color_danger_750 = "#79070F";
export const primitives_color_danger_800 = "#63080A";
export const primitives_color_danger_850 = "#4D0B06";
export const primitives_color_danger_900 = "#340F06";
export const primitives_color_danger_950 = "#1F0B04";
export const primitives_color_selected_50 = "#E3F5EC";
export const primitives_color_selected_100 = "#C8EADA";
export const primitives_color_selected_150 = "#AEDFC9";
export const primitives_color_selected_200 = "#95D4B9";
export const primitives_color_selected_250 = "#7DC8A9";
export const primitives_color_selected_300 = "#66BC99";
export const primitives_color_selected_350 = "#50AF8B";
export const primitives_color_selected_400 = "#3CA27D";
export const primitives_color_selected_450 = "#279570";
export const primitives_color_selected_500 = "#168764";
export const primitives_color_selected_550 = "#047A58";
export const primitives_color_selected_600 = "#026C4E";
export const primitives_color_selected_650 = "#045F44";
export const primitives_color_selected_700 = "#09513A";
export const primitives_color_selected_750 = "#0F4432";
export const primitives_color_selected_800 = "#103729";
export const primitives_color_selected_850 = "#112A20";
export const primitives_color_selected_900 = "#101E18";
export const primitives_color_selected_950 = "#09130F";
export const primitives_color_focus_50 = "#EFF0FB";
export const primitives_color_focus_100 = "#DEE2F9";
export const primitives_color_focus_150 = "#CCD3F9";
export const primitives_color_focus_200 = "#BAC5F9";
export const primitives_color_focus_250 = "#A7B7FA";
export const primitives_color_focus_300 = "#94A9F9";
export const primitives_color_focus_350 = "#7F9BF8";
export const primitives_color_focus_400 = "#678EF7";
export const primitives_color_focus_450 = "#4A81F6";
export const primitives_color_focus_500 = "#2871E7";
export const primitives_color_focus_550 = "#2469D7";
export const primitives_color_focus_600 = "#1F5DC0";
export const primitives_color_focus_650 = "#1A51A9";
export const primitives_color_focus_700 = "#164593";
export const primitives_color_focus_750 = "#103A7D";
export const primitives_color_focus_800 = "#102F67";
export const primitives_color_focus_850 = "#0E2551";
export const primitives_color_focus_900 = "#0B1B3C";
export const primitives_color_focus_950 = "#081028";
export const primitives_color_yellow_50 = "#FCEEE4";
export const primitives_color_yellow_100 = "#FCDCC3";
export const primitives_color_yellow_150 = "#FCCAA0";
export const primitives_color_yellow_200 = "#FEB677";
export const primitives_color_yellow_250 = "#FFA148";
export const primitives_color_yellow_300 = "#FD8C01";
export const primitives_color_yellow_350 = "#EA8100";
export const primitives_color_yellow_400 = "#D77600";
export const primitives_color_yellow_450 = "#C46B00";
export const primitives_color_yellow_500 = "#B16100";
export const primitives_color_yellow_550 = "#A05600";
export const primitives_color_yellow_600 = "#8E4C00";
export const primitives_color_yellow_650 = "#7D4200";
export const primitives_color_yellow_700 = "#6C3900";
export const primitives_color_yellow_750 = "#5B3000";
export const primitives_color_yellow_800 = "#4A2702";
export const primitives_color_yellow_850 = "#391F04";
export const primitives_color_yellow_900 = "#281805";
export const primitives_color_yellow_950 = "#180F04";
export const primitives_color_blue_50 = "#EFF0FB";
export const primitives_color_blue_100 = "#DEE2F9";
export const primitives_color_blue_150 = "#CCD3F9";
export const primitives_color_blue_200 = "#BAC5F9";
export const primitives_color_blue_250 = "#A7B7FA";
export const primitives_color_blue_300 = "#94A9F9";
export const primitives_color_blue_350 = "#7F9BF8";
export const primitives_color_blue_400 = "#678EF7";
export const primitives_color_blue_450 = "#4A81F6";
export const primitives_color_blue_500 = "#2871E7";
export const primitives_color_blue_550 = "#2469D7";
export const primitives_color_blue_600 = "#1F5DC0";
export const primitives_color_blue_650 = "#1A51A9";
export const primitives_color_blue_700 = "#164593";
export const primitives_color_blue_750 = "#103A7D";
export const primitives_color_blue_800 = "#102F67";
export const primitives_color_blue_850 = "#0E2551";
export const primitives_color_blue_900 = "#0B1B3C";
export const primitives_color_blue_950 = "#081028";
export const primitives_color_green_50 = "#E3F5EC";
export const primitives_color_green_100 = "#C8EADA";
export const primitives_color_green_150 = "#AEDFC9";
export const primitives_color_green_200 = "#95D4B9";
export const primitives_color_green_250 = "#7DC8A9";
export const primitives_color_green_300 = "#66BC99";
export const primitives_color_green_350 = "#50AF8B";
export const primitives_color_green_400 = "#3CA27D";
export const primitives_color_green_450 = "#279570";
export const primitives_color_green_500 = "#168764";
export const primitives_color_green_550 = "#047A58";
export const primitives_color_green_600 = "#026C4E";
export const primitives_color_green_650 = "#045F44";
export const primitives_color_green_700 = "#09513A";
export const primitives_color_green_750 = "#0F4432";
export const primitives_color_green_800 = "#103729";
export const primitives_color_green_850 = "#112A20";
export const primitives_color_green_900 = "#101E18";
export const primitives_color_green_950 = "#09130F";
export const primitives_color_red_50 = "#FBEEEB";
export const primitives_color_red_100 = "#FADBD5";
export const primitives_color_red_150 = "#FAC8BF";
export const primitives_color_red_200 = "#FBB4A7";
export const primitives_color_red_250 = "#FD9F8F";
export const primitives_color_red_300 = "#FC8977";
export const primitives_color_red_350 = "#FC715F";
export const primitives_color_red_400 = "#FB5347";
export const primitives_color_red_450 = "#FB252E";
export const primitives_color_red_500 = "#E61827";
export const primitives_color_red_550 = "#CF1522";
export const primitives_color_red_600 = "#B9111D";
export const primitives_color_red_650 = "#A30E18";
export const primitives_color_red_700 = "#8E0A14";
export const primitives_color_red_750 = "#79070F";
export const primitives_color_red_800 = "#63080A";
export const primitives_color_red_850 = "#4D0B06";
export const primitives_color_red_900 = "#340F06";
export const primitives_color_red_950 = "#1F0B04";
export const primitives_color_collection_boutique = "#1F448D";
export const primitives_color_collection_cycling = "#333333";
export const primitives_color_collection_excellent = "#5E2F7E";
export const primitives_color_collection_famfun = "#ED2924";
export const primitives_color_collection_secrets = "#00BFD4";
export const primitives_color_collection_selections = "#F66E20";
export const primitives_color_collection_villages = "#147A58";
export const primitives_color_collection_xperience = "#ED2924";
export const primitives_color_collection_atlantis = "#FE6400";
export const primitives_color_collection_totally = "#FF6600";
export const primitives_color_collection_primavera = "#00B49D";
export const primitives_color_collection_child = "#FDA932";
export const primitives_color_collection_culinary = "#EB581F";
export const primitives_color_collection_honeymoon = "#AA121B";
export const primitives_color_collection_sustainable = "#167D6B";
export const primitives_color_collection_pearls = "#1E2D84";
export const primitives_color_collection_newest_discoveries = "#611D97";
export const primitives_color_collection_diamond = "#8CD5E4";
export const primitives_color_collection_gold = "#FDDD00";
export const primitives_color_collection_springbreak = "#9EE1D4";
export const primitives_color_collection_budget = "#F6A6B3";
export const primitives_color_collection_gogo_toppers = "#FFDD00";
export const primitives_color_collection_gogo_suggestions = "#F6A6B3";
export const primitives_color_collection_adults_only = "#8CD5E5";
export const primitives_font_family_body = "General Sans";
export const primitives_font_family_body_fallback = "system-ui";
export const primitives_font_family_display = "Branding";
export const primitives_font_family_display_fallback = "system-ui";
export const primitives_font_weight_body_hairline = "Extralight";
export const primitives_font_weight_body_thin = "Light";
export const primitives_font_weight_body_light = "Regular";
export const primitives_font_weight_body_regular = "Medium";
export const primitives_font_weight_body_medium = "Medium";
export const primitives_font_weight_body_semi_bold = "Semibold";
export const primitives_font_weight_body_bold = "Semibold";
export const primitives_font_weight_body_extra_bold = "Bold";
export const primitives_font_weight_body_black = "Bold";
export const primitives_font_weight_display_hairline = "Medium";
export const primitives_font_weight_display_thin = "Medium";
export const primitives_font_weight_display_light = "Medium";
export const primitives_font_weight_display_regular = "Medium";
export const primitives_font_weight_display_medium = "Semibold";
export const primitives_font_weight_display_semi_bold = "Semibold";
export const primitives_font_weight_display_bold = "Bold";
export const primitives_font_weight_display_extra_bold = "Bold";
export const primitives_font_weight_display_black = "Bold";
export const primitives_font_size_display_a = 64;
export const primitives_font_size_display_b = 48;
export const primitives_font_size_display_c = 40;
export const primitives_font_size_display_d = 36;
export const primitives_font_size_display_e = 32;
export const primitives_font_size_display_f = 28;
export const primitives_font_size_display_g = 24;
export const primitives_font_size_display_h = 20;
export const primitives_font_size_display_i = 18;
export const primitives_font_size_display_j = 16;
export const primitives_font_size_body_l = 18;
export const primitives_font_size_body_m = 16;
export const primitives_font_size_body_s = 14;
export const primitives_font_size_body_xs = 12;
export const primitives_line_height_snug = 1.5;
export const primitives_line_height_loose = 1.75;
export const primitives_line_height_tight = 1.25;
export const primitives_line_height_flat = 1.125;
export const primitives_opacities_disabled = 38;
export const primitives_corner_radius_none = 0;
export const primitives_corner_radius_xs = 2;
export const primitives_corner_radius_s = 4;
export const primitives_corner_radius_m = 6;
export const primitives_corner_radius_l = 8;
export const primitives_corner_radius_xl = 12;
export const primitives_corner_radius_xxl = 16;
export const primitives_corner_radius_full = 9999;
export const primitives_space_0 = 0;
export const primitives_space_2 = 2;
export const primitives_space_4 = 4;
export const primitives_space_6 = 6;
export const primitives_space_8 = 8;
export const primitives_space_12 = 12;
export const primitives_space_16 = 16;
export const primitives_space_20 = 20;
export const primitives_space_24 = 24;
export const primitives_space_28 = 28;
export const primitives_space_32 = 32;
export const primitives_space_40 = 40;
export const primitives_space_44 = 44;
export const primitives_space_48 = 48;
export const primitives_space_56 = 56;
export const primitives_space_64 = 64;
export const primitives_space_80 = 80;
export const primitives_space_96 = 96;
export const primitives_area_size_120 = 120;
export const primitives_area_size_160 = 160;
export const primitives_area_size_200 = 200;
export const primitives_area_size_240 = 240;
export const primitives_area_size_320 = 320;
export const primitives_area_size_360 = 360;
export const primitives_area_size_400 = 400;
export const primitives_area_size_480 = 480;
export const primitives_area_size_640 = 640;
export const primitives_area_size_720 = 720;
export const primitives_area_size_800 = 800;
export const primitives_area_size_960 = 960;
export const primitives_area_size_1280 = 1280;
export const primitives_area_size_1440 = 1440;
export const primitives_breakpoint_s_min = 320;
export const primitives_breakpoint_s_max = 640;
export const primitives_breakpoint_m_min = 641;
export const primitives_breakpoint_m_max = 1007;
export const primitives_breakpoint_l_min = 1008;
export const primitives_box_shadows_level_1 = "0px 2px 4px 0px rgba(0, 0, 0, 0.11), 0px 0px 2px 0px rgba(0, 0, 0, 0.09)";
export const primitives_box_shadows_level_2 = "0px 2px 8px 0px rgba(0, 0, 0, 0.1), 0px 1px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)";
export const primitives_box_shadows_level_3 = "0px 4px 16px 0px rgba(0, 0, 0, 0.12), 0px 2px 8px 0px rgba(0, 0, 0, 0.06), 0px 1px 4px 0px rgba(0, 0, 0, 0.05), 0px 0px 2px 0px rgba(0, 0, 0, 0.04)";
export const primitives_box_shadows_level_4 = "0px 8px 32px 0px rgba(0, 0, 0, 0.1), 0px 4px 16px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px 0px rgba(0, 0, 0, 0.06), 0px 1px 4px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.02)";
export const primitives_box_shadows_level_5 = "0px 16px 64px 0px rgba(0, 0, 0, 0.11), 0px 8px 32px 0px rgba(0, 0, 0, 0.09), 0px 4px 16px 0px rgba(0, 0, 0, 0.06), 0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.03), 0px 0px 2px 0px rgba(0, 0, 0, 0.02)";
export const primitives_box_shadows_level_6 = "0px 32px 128px 0px rgba(0, 0, 0, 0.16), 0px 16px 64px 0px rgba(0, 0, 0, 0.1), 0px 8px 32px 0px rgba(0, 0, 0, 0.08), 0px 4px 16px 0px rgba(0, 0, 0, 0.06), 0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.03), 0px 0px 2px 0px rgba(0, 0, 0, 0.02)";
export const typography_body_s_bold_loose_font_size = 14;
export const typography_body_s_bold_loose_font_family = "General Sans";
export const typography_body_s_bold_loose_font_weight = "Semibold";
export const typography_body_s_bold_loose_line_height = 1.75;
export const typography_body_s_bold_loose_letter_spacing = "0";
export const typography_body_s_bold_loose_text_transform = "none";
